export const ROUTES = {
  bill: 'bill',
  payout: 'payout',
  cabinet: 'cabinet',
  projects: 'projects',
  projectCreate: 'projectCreate',
};

export const PENDING = 'PENDING';
export const APPROVED = 'APPROVED';
export const PERSONAL = 'PERSONAL';
export const PARTNER = 'PARTNER';
